function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.3 22.21C31.88 20.13 27.76 14.11 26.95 6.7C26.8998 6.26011 26.9546 5.81459 27.11 5.4C26.28 5.4 25.42 5.35 24.5 5.35C23.58 5.35 22.72 5.35 21.89 5.4C22.0453 5.81459 22.1002 6.26011 22.05 6.7C21.23 14.23 16.98 20.32 11.42 22.31",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.89 5.4C21.7915 5.0221 21.5778 4.68424 21.2785 4.43335C20.9792 4.18247 20.6093 4.031 20.22 4H9.33998C8.78406 4.07967 8.28103 4.37272 7.93754 4.81702C7.59404 5.26132 7.4371 5.82194 7.49998 6.38V20.45C7.49998 21.89 8.49998 23 9.58998 22.82C10.2137 22.7039 10.8261 22.5333 11.42 22.31C16.98 20.31 21.23 14.23 22.05 6.7C22.1002 6.26011 22.0453 5.81459 21.89 5.4V5.4Z",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M39.66 4H28.78C28.3907 4.031 28.0207 4.18247 27.7215 4.43335C27.4222 4.68424 27.2085 5.0221 27.11 5.4C26.9546 5.81459 26.8998 6.26011 26.95 6.7C27.76 14.11 31.88 20.13 37.3 22.21C37.9818 22.4814 38.6885 22.6857 39.41 22.82C40.5 23 41.5 21.89 41.5 20.45V6.38C41.5629 5.82194 41.4059 5.26132 41.0624 4.81702C40.7189 4.37272 40.2159 4.07967 39.66 4V4Z",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 23V36C11.5 38 11.5 42 16.5 42C21.5 42 23.5 33 24.5 33C25.5 33 27.5 42 32.5 42C37.5 42 37.5 38 37.5 36V23",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 42C17.5 42 18.5 46 24.5 46C30.5 46 30.5 42 30.5 42",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 26C20.0523 26 20.5 25.5523 20.5 25C20.5 24.4477 20.0523 24 19.5 24C18.9477 24 18.5 24.4477 18.5 25C18.5 25.5523 18.9477 26 19.5 26Z",
  fill: "#ACB5BF"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5 26C30.0523 26 30.5 25.5523 30.5 25C30.5 24.4477 30.0523 24 29.5 24C28.9477 24 28.5 24.4477 28.5 25C28.5 25.5523 28.9477 26 29.5 26Z",
  fill: "#ACB5BF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5 33C26.1569 33 27.5 32.1046 27.5 31C27.5 29.8954 26.1569 29 24.5 29C22.8431 29 21.5 29.8954 21.5 31C21.5 32.1046 22.8431 33 24.5 33Z",
  stroke: "#FFD200",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPet);
export default __webpack_public_path__ + "static/media/pet.ef7825f2.svg";
export { ForwardRef as ReactComponent };